<app-main-header [breadcrumbs]="breadcrumbs"></app-main-header>

<ion-content>
  <div class="container-fluid custom-container-fluid my-2">
    <div
      class="mb-4 d-flex justify-content-center mt-5"
      *ngIf="valve_form.isFetchingData"
    >
      <div class="spinner-border text-warning" role="status">
        <span class="visually-hidden">{{ 'irrigation_loading' | translation }}</span>
      </div>
    </div>
    <div
      *ngIf="
        !isFetchingData && !valve_form.isFetchingData && !isValvesWithoutData
      "
    >
      <div class="mb-2">
        <div class="row">
          <app-generic-header
            *ngIf="valves && valve"
            [elements]="valves"
            [text]="'name'"
            [selected]="valve"
            [placeholder]="'irrigation_change_valve' | translation"
            [elementSearchId]="'valve'"
            [label]="'irrigation_valve' | translation"
            (changeSelected)="onChangePagination($event)"
          >
            <div irrigation>
              <div class="row justify-content-end">
                <div class="col-auto ps-0 dots">
                  <app-mode
                    *ngIf="!isValvesWithoutData"
                    (changeEventEmitter)="mode = $event"
                  ></app-mode>
                </div>
              </div>
            </div>
          </app-generic-header>
        </div>
      </div>
    </div>
    <div class="card" style="margin-top: 16px">
      <div class="row">
        <div
          class="col-12 col-md-6"
          [style.display]="valve_form.isFetchingData ? 'none' : 'block'"
        >
          <app-valves-form
            [mode]="mode"
            [terminal_vid]="terminal_vid"
            [valve_id]="valve_id"
            (dirtyEventEmitter)="isDirty = $event"
            (valveEventEmitter)="valve = $event; getValvesManager()"
            #valve_form
          ></app-valves-form>
        </div>
        <div
          class="col-12 col-md-6"
          [style.display]="valve_form.isFetchingData ? 'none' : 'block'"
        >
          <h6 style="font-weight: normal; font-size: 0.8125rem">
            {{ 'irrigation_edit_valves_help' | translation }}
          </h6>
          <lib-leaflet-maps
            *ngIf="valve !== undefined && manageValve !== undefined"
            [coming]="'valves-edit' + valve.valve"
            [valve]="this.manageValve"
            (changeValve)="
              this.valve = $event;
              this.manageValve = $event;
              valve_form.valvesForm.value.isDirty = true
            "
          ></lib-leaflet-maps>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<footer
  *ngIf="!isValvesWithoutData && !isFetchingTitle"
  class="footer mt-auto px-4 py-3 bg-light-soft border-top-3 border-light border global-irrigation-save-button"
>
  <div *ngIf="!terminalData?.authed_user_can_write" class="row">
    <div class="col">
      <app-cannot-write-alert></app-cannot-write-alert>
    </div>
  </div>
  <div class="d-flex justify-content-end" *ngIf="!saveButtonTimeElapsed">
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">{{ 'climate_loading' | translation }}</span>
    </div>
  </div>
  <div
    *ngIf="terminalData?.authed_user_can_write && saveButtonTimeElapsed"
    class="row"
  >
    <div
      class="col irrigation-save-button"
      [ngClass]="{ 'p-0': !hasScrollbar }"
    >
      <button
        (click)="valve_form.submitForm(this.manageValve)"
        [disabled]="
          !valve_form.valvesForm.value.isDirty && !valve_form.valvesForm.dirty
        "
        class="btn btn-primary float-end"
        [ngClass]="{
          'btn-danger':
            valve_form.valvesForm.value.isDirty || valve_form.valvesForm.dirty
        }"
      >
        <span
          *ngIf="valve_form.isFormSubmitted"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        {{ valve_form.isFormSubmitted
            ? ('saving' | translation)
            : ('irrigation_save_valve' | translation) }}
      </button>
    </div>
  </div>
</footer>
